export default __webpack_public_path__ + "c1060544a438c21cc6404b9e20926495.png";